import { createContext, useState } from 'react'

import type { IInputTextProps } from '../types'

export interface InputTextPropsProviderProps extends IInputTextProps {
  children: React.ReactNode
  value: string
}

export interface InputTextContextProps
  extends Omit<IInputTextProps, 'children'> {
  isActive: boolean
  setIsActive: (value: boolean) => void
  inputValue: string
  isFilled: boolean
}

export const InputTextContext = createContext<InputTextContextProps>({
  isActive: false,
  setIsActive: (value: boolean) => {},
  inputValue: '',
  isFilled: false,
  errorText: '',
})

const { Provider } = InputTextContext

export function InputTextProvider({
  children,
  value,
  ...props
}: InputTextPropsProviderProps) {
  const [isActive, setIsActive] = useState(false)

  const customProps = {
    ...props,
    isActive,
    setIsActive,
    inputValue: value,
    isFilled: value.length > 0,
  }
  return <Provider value={{ ...customProps }}>{children}</Provider>
}
